import React from 'react';
import { NavigationProps } from '../types/navigation';
import { Button } from '../components/ui/Button';
import { Users, Calendar, Lock } from 'lucide-react';
import { useStore } from '../lib/store';
export function FeedPage({
  onNavigate
}: NavigationProps) {
  const {
    events,
    user
  } = useStore();
  const upcomingCampaigns = events;
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-400">
      {/* Header */}
      <header className="bg-gradient-to-b from-[#67E8F9] to-[#E0F2FE] px-6 pt-12 pb-12 rounded-b-[2.5rem] shadow-sm relative overflow-hidden" data-id="element-401">
        <div className="relative z-10 flex justify-between items-start mb-6" data-id="element-402">
          <div data-id="element-403">
            <p className="text-blue-900/60 font-bold text-xs uppercase tracking-wider mb-1" data-id="element-404">
              Welcome back
            </p>
            <h1 className="text-3xl font-black text-gray-900" data-id="element-405">
              {user?.name || 'Fisher'}
            </h1>
          </div>
          <div className="bg-white/80 backdrop-blur-sm px-4 py-2 rounded-2xl shadow-sm border border-white/50" data-id="element-406">
            <span className="text-sm font-bold text-blue-900 block leading-none" data-id="element-407">
              {user?.points || 0}
            </span>
            <span className="text-[10px] font-bold text-blue-400 uppercase" data-id="element-408">
              Points
            </span>
          </div>
        </div>
      </header>

      <div className="px-4 -mt-6 relative z-20 space-y-6" data-id="element-409">
        <h2 className="text-xl font-black text-gray-900 px-2" data-id="element-410">Coming Soon</h2>

        {upcomingCampaigns.map(event => {
        // Logic: If user is NOT eligible (hasn't reviewed), show lock state
        // Unless it's the very first event they just registered for (which is handled by activeEventId usually)
        // For MVP simplicity: if eligible_for_next_event is false, show lock overlay on future events
        const isLocked = !user?.eligible_for_next_event && event.type === 'reservation';
        return <div key={event.id} className="bg-white rounded-[1.5rem] p-1 shadow-sm border border-gray-100 group hover:shadow-md transition-all duration-300 relative overflow-hidden" data-id="element-411">
              {isLocked && <div className="absolute inset-0 bg-gray-900/80 backdrop-blur-sm z-30 flex flex-col items-center justify-center text-center p-6" data-id="element-412">
                  <div className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center mb-3 border border-gray-700" data-id="element-413">
                    <Lock className="w-6 h-6 text-gray-400" data-id="element-414" />
                  </div>
                  <h3 className="text-white font-bold text-lg mb-1" data-id="element-415">
                    Drop Locked
                  </h3>
                  <p className="text-gray-400 text-sm mb-4" data-id="element-416">
                    Review your previous catch to see details.
                  </p>
                  <Button variant="secondary" onClick={() => onNavigate('catches')} className="bg-white text-black hover:bg-gray-100" data-id="element-417">
                    Go to Reviews
                  </Button>
                </div>}

              <div className="relative h-40 bg-gray-900 rounded-[1.2rem] overflow-hidden mb-3" data-id="element-418">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-900 to-purple-900 opacity-90 flex items-center justify-center" data-id="element-419">
                  <div className="text-center" data-id="element-420">
                    <span className="text-blue-300 text-xs font-bold uppercase tracking-widest mb-2 block" data-id="element-421">
                      {event.theme}
                    </span>
                    <h3 className="text-2xl font-black text-white mb-1" data-id="element-422">
                      {event.title}
                    </h3>
                    <div className="flex items-center justify-center text-blue-200 text-sm font-medium mt-2" data-id="element-423">
                      <Calendar className="w-4 h-4 mr-1.5" data-id="element-424" />
                      {event.date}
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-4 pb-4" data-id="element-425">
                <p className="text-gray-500 text-sm mb-4 text-center italic" data-id="element-426">
                  "Something fishy is coming..."
                </p>

                <Button variant="secondary" onClick={() => onNavigate('friends')} className="w-full bg-blue-50 text-blue-600 border-blue-100 hover:bg-blue-100" data-id="element-427">
                  <Users className="w-4 h-4 mr-2" data-id="element-428" />
                  Invite Friends to Unlock
                </Button>
              </div>
            </div>;
      })}
      </div>
    </div>;
}